export const FLOW_NAME = "text-mining";
export type FLOW_TYPE = "text-mining";

export const INPUT_DATA = "data";
export const WORD_MAPPER_DATA = "word-mapper";

export const TEXT_COLUMNS_KEY = "text-id";
export const WORD_MAPPER_KEY_NAME = "words-to-be-mapped";
export const WORD_MAPPER_VALUE_NAME = "word-mapping-destination";

export const TIME_COLUMN_KEY = "time-column";
export const TIME_RESOLUTION_KEY = "time_resolution";

export const NUM_TOPICS_KEY = "num-topics";
export const DOC_SIZE_THRESH_KEY = "doc-size-threshold";
export const WORD_FREQ_THRESH_KEY = "word-frequency-threshold";
export const DOC_FREQ_THRESH_KEY = "doc-frequency-threshold";

export const RECIPE_NAME = "text-mining-topic-extraction-words-time-series-etc";

export const ALGORITHMS = ["tokenization"];
